module.exports = __webpack_public_path__ + "img/avatar-gender-w-n.7eb0d347.png";